var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "134",
        viewBox: "0 0 178 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M0 133.106H177.09V0H0V133.106Z", fill: "#F47277" },
      }),
      _c("path", {
        attrs: {
          d: "M150.645 133.447H0V21C83.1963 21 150.645 71.3463 150.645 133.447Z",
          fill: "#E93338",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }